<template>
  <div style="padding:10px">

    <van-tabs v-model="active">
      <van-tab title="Genel">

        <van-field :value="obje.genel.evrak+' # '+obje.genel.evrak2" label="Evrak" disabled />
        <van-field :value="$helper.parabirimi(obje.toplam.aratoplam,hesap.pb)" label="Ara toplam" disabled />
        <van-field :value="$helper.parabirimi(obje.toplam.geneltoplam,hesap.pb)" label="toplam" disabled />
        <van-field :value="$helper.parabirimi(obje.toplam.iskonto1,hesap.pb)" label="İskonto1" disabled />
        <van-field :value="$helper.parabirimi(obje.toplam.iskonto2,hesap.pb)" label="İskonto2" disabled />
        <van-field :value="$helper.parabirimi(obje.toplam.vergi,hesap.pb)" label="vergi" disabled />




      </van-tab>
      <van-tab title="Detay">
        <van-cell-group v-for="(item, index) in obje.kalem" :key="index">
          <van-cell  :title="item.isim" :label="item.adet+' adet '+$helper.parabirimi(item.isk_birim_fiyat,hesap.pb)" icon="success" style="padding-left:2px" :value="$helper.parabirimi((item.isk_birim_fiyat * item.adet)+item.vergi,hesap.pb)" />
        </van-cell-group>
    </van-tab> 
      <van-tab title="Fatura" @click="active = 1">

        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o"
          style="margin-top:10px">{{mesaj}}</van-notice-bar>
        <van-grid :gutter="10">
          <van-grid-item v-for="(item, index) in list" :key="index">
            <van-image @click="previewShow = true"  width="2rem" height="2rem" fit="fixed" :src="item.response" />
          </van-grid-item>
        </van-grid>
      </van-tab>
     
    </van-tabs>
      <van-image-preview v-model="previewShow" :images="list2" @change="onChange">
        <template v-slot:index>Evrak: {{ index+1 }}</template>
      </van-image-preview>
  </div>
</template>

<script>


export default {
  data() {
    return {
      previewShow:false,
      index: 0,
      hesap : this.$store.getters.getHesap,

      mesaj:'Fatura Yüklenmemiş',
      active: 0,
      obje: this.$store.getters.getFoy,
      fileList: [],


    };
  },
  created() {
    //this.depogetir()
    //this.hesap()
    this.$store.commit('setMenu',false)
    //this.filesgetir() bu fatura getir olacak
  },
  methods: {

    upload() {
      this.$store.commit("setLoading",[true,'Bekleyin'])

      let giden = {
        dir: ['stok',this.obje.kod,this.$route.params.id],
        list: this.fileList,
        request: this.$request
      }
      this.$store.dispatch('upload', giden).then(res => {

        this.fileList = [];
        this.$store.commit("setLoading",[false,'Tamamlandı'])
      })
    },
    filesgetir() {
      this.$store.commit("setLoading",[true,'Yükleniyor'])
      this.$store.dispatch('getFiles', { request: this.$request, folder: 'stok/'+this.obje.kod+'/'+this.$route.params.id }).then(res => {
        this.list= res.data
        this.list.forEach(e => {
          this.list2.push(e.response)
        });
        this.$store.commit("setLoading",[false,'Tamamlandı'])
      })
    },
    afterRead(file) {
      let index = this.fileList.findIndex(obj => obj.file.name === file.file.name);
      Object.assign(this.fileList[index], {name:file.file.name})
    },
    onChange(index) {
      this.index = index;
    }, 
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ekstredetay.vue